import React, { useEffect, useMemo } from 'react';
import useFetchedData from 'hooks/useFetchedData';
import { transformToAnalyticsItems, triggerAnalyticEvent } from 'utils/analytics';
import { getItemTotalPrice } from 'utils/item';
import { useLocation } from 'react-router-dom';
import ModifierProvider from './ModifierProvider';

import ItemModal from './ItemModal';
import { sortModifierOptions } from './utils';

function Item({
  itemId, onBack, open, showSpecialNote, available,
}) {
  const { state: { item: stateItem } = {} } = useLocation();
  const { data: { data: fetchedItem } = {} } = useFetchedData(
    itemId && {
      url: `v1/items/${itemId}/`,
    },
  );
  const item = useMemo(() => sortModifierOptions({ ...stateItem, ...fetchedItem }), [stateItem, fetchedItem]);

  useEffect(() => {
    if (!open || !item) {
      return;
    }

    triggerAnalyticEvent('view_item', {
      value: getItemTotalPrice(item),
      currency: 'USD',
      items: transformToAnalyticsItems({
        items: [item],
      }),
    });
  }, [open, item]);

  return (
    <ModifierProvider modifiers={item?.modifiers}>
      <ItemModal
        open={open}
        onClose={onBack}
        item={item}
        showSpecialNote={showSpecialNote}
        available={available}
      />
    </ModifierProvider>
  );
}

export default Item;
